import React from 'react';

function DataIngestionTitle(props){
    return(
        <div className='container'>
            <div className={` row dataingestiontitlecolumn ${props.cname}`}>
                <div>Activity Code</div>
                <div>Activity Name</div>
                <div>Unit of Measure</div>
                <div>GANG Quantity (Aprved by PM)</div>
            </div>
                <div>{props.component}</div>
        </div>
    )
};

export default DataIngestionTitle;